import {
  Box,
  Button,
  Divider,
  Modal,
  Paper,
  Typography,
} from "@material-ui/core";
import React from "react";
import { fontsName } from "../../assets/fonts/fontsName";
import modalImage from "../../assets/images/leadership.jpg";
import example from "../../assets/images/show-example.png";

const GuideModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} style={{ overflow: "scroll" }}>
      <Paper className="modal-paper" style={{ borderRadius: "25px" }}>
        <Box className="modal-paper-part" id="first">
          <img
            src={modalImage}
            style={{ width: "100%", borderRadius: "15px" }}
          />
        </Box>
        <Box className="modal-paper-part" id="second" dir="rtl">
          <Typography
            variant="h4"
            style={{
              fontFamily: fontsName.PersianRoyaBold,
              textAlign: "right",
            }}
          >
            راهنما
          </Typography>
          <Divider style={{ margin: "8px 0px" }} />
          <Typography
            paragraph={true}
            style={{
              fontFamily: fontsName.PersianRoyaBold,
              textAlign: "right",
            }}
          >
            برای ورود به رایسا باید بر روی دکمه آبی که در بخش بالایی صفحه قرار
            داده شده کلیک کنید. مطابق شکل زیر
          </Typography>
          <img
            src={example}
            style={{
              width: "100%",
              height: "30px",
              border: "1px solid #e1e1e1",
            }}
          />
          <Button
            variant="contained"
            style={{
              fontFamily: fontsName.PersianRoya,
              backgroundColor: "#0097e6",
              fontSize: "18px",
              color: "#fff",
              padding: "3px 15px",
              marginTop: "25px",
              width: "25%",
              alignContent: "end",
              borderRadius: "10px",
            }}
            onClick={onClose}
          >
            بستن
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export default GuideModal;
